
const defaultState: { [ key: string ]: any } = {

  deliverableReviewSettings: {
    cycles:  1,
    review:  5,
    update:  5,
    approve: 2
  },

  timeline: {
    zoom: 1
  }
};




const getFromState = (state: any, key: string) => {

  if (state) {

    const value = state[key];

    if (value) {
      return value;

    } else {
      return defaultState[key];
    }

  } else {
    return defaultState[key];
  }
};




const putIntoState = () => {
  return {};
};



export {
  getFromState,
  putIntoState
};
